<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W5wn52/tc-custom/9781800320581.jpg?1724854661424" alt="This image is the cover for the book King's Chameleon, Kit Faulkner Naval Adventures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">King's Chameleon, Kit Faulkner Naval Adventures
      </h1>
      <p class="bookDescription body article font2">
        <p>The shattering finale to the Kit Faulkner naval adventures.</p><p>England, 1659. <b>Captain Kit Faulkner</b>’s house is prospering; his eldest son has recently returned from a profitable trip to Jamaica in the good ship <i>Faithful</i>, and his daughter is to be married.</p><p>But the resignation of the Lord Protector, <b>Richard Cromwell</b>, throws England into uncertainty. Will the republic flourish, or will a King return to the throne?</p><p>Kit is content to let matters take their natural course, but his younger son, <b>Henry</b>, is an idealist with political ambitions. It soon becomes clear that Henry is in much deeper than Kit first realised, and his son’s actions may threaten everything Kit holds dear…</p><p><b>An absolutely gripping maritime thriller, perfect for fans of Hornblower, C. S. Forrester and Patrick O’Brian.</b></p>Praise for Richard Woodman<p>‘A sure bet for Patick O’Brian fans’ <i>Library Journal</i></p><p>‘Woodman spins an exciting tale’ <i>Publishers Weekly</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Woodman
      </h2>
      
      <p class="authorDescription body article"><P>Richard Woodman is a prolific author of historical fiction, and was born in London in 1944. He became an indentured midshipman in cargo liners at the age of sixteen and has sailed in a variety of ships, serving from apprentice to captain. In 1978 he won the Marine Society's Harmer Award. This experience gives his naval fiction a rich authenticity, and spurred him to write over forty historical novels, as well as a series on the history of the British Merchant Navy, alongside many other non-fiction historical books.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?272c6d54